import { SagaIterator } from 'redux-saga';
import { call, select } from 'redux-saga/effects';
import { ClientError, FailureOperation } from '../../../models/common';
import { FeatureFlagSet } from '../../../models/features';
import {
    applyFeaturesToCurrentLocation,
    getFeaturesFromCurrentLocation,
    toggleFeatureFlagsInSet,
} from '../../../utilities/features';
import { trackException } from '../../../utilities/telemetry/channel';
import { replaceCurrentLocation } from '../../../utilities/url';
import { toggleFeatures } from '../../actions/features/features-action-creators';
import { ToggleFeaturesAction } from '../../actions/features/features-actions';
import { createSagaError } from '../../effects/create-saga-error';
import { takeEvery } from '../../effects/take';
import { getFrozenFeatures } from '../../selector/features-selectors';
import { getPayload } from '../../utilities/payload-action';

export function* toggleFeaturesSaga(action: ToggleFeaturesAction): SagaIterator {
    const { features } = getPayload(action);

    try {
        const featureFlags: FeatureFlagSet = yield call(getFeaturesFromCurrentLocation);
        const newFeatureFlags: FeatureFlagSet = yield call(toggleFeatureFlagsInSet, featureFlags, ...features);
        const frozenFeatures: FeatureFlagSet = yield select(getFrozenFeatures);
        const newUrl: URL = yield call(applyFeaturesToCurrentLocation, newFeatureFlags, frozenFeatures);

        yield call(replaceCurrentLocation, newUrl);
    } catch (err) {
        // No error actions for updating features - we just log the exception
        const error: ClientError = yield createSagaError(err, FailureOperation.ToggleFeatures);
        yield call(trackException, error);
    }
}

export function* toggleFeaturesListenerSaga(): SagaIterator {
    yield takeEvery(toggleFeatures, toggleFeaturesSaga);
}
